<template>
  <div class="render">
    <v-overlay :value="replacing" opacity="0.6">
      <div class="overlay-box">
        <v-progress-circular indeterminate size="28" class="mr-3" />
        <div>
          <div class="overlay-title">Идёт замена номеров…</div>
          <div class="overlay-sub">
            Старые номера переводим в статус "Только входящие", создаём новую
            карусель
          </div>
        </div>
      </div>
    </v-overlay>

    <v-snackbar v-model="snack.show" timeout="4000">{{
      snack.text
    }}</v-snackbar>

    <SelectNumbersModal
      ref="selModal"
      v-model="modal"
      :mode="'new'"
      :carousels="selects_load.carousels"
      @confirm="handleConfirm"
      @created="handleCreated"
    />

    <QuickReserveModal
      v-model="modalReserveQuick"
      @created="onQuickReserveCreated"
    />

    <EditCarouselModal
      v-model="modalEdit"
      :carousel="editingCarousel"
      @save="saveCarousel"
    />

    <EditReserveUserModal
      v-model="modalReserveUser"
      :reserve="editingReserveUser"
      @save="saveReserveUser"
    />

    <ReserveMarkingModal
      v-model="modalReserve"
      :mode="reserveMode"
      :is-admin="false"
      :reserve="editingReserve"
      :status="editingReserve?.status || 'review'"
      :markings="selects_load.markings"
      @create="onReserveCreate"
      @save="onReserveSave"
    />

    <div class="top"><h1>Ваши номера</h1></div>

    <div class="my_toolbar">
      <v-tabs v-model="tab" align-with-title class="tabs">
        <v-tabs-slider color="#4B5EFF" />
        <v-tab
          v-for="t in tabs"
          :key="t.value"
          :href="'#' + t.value"
          class="item_tab"
          active-class="my_active_tab"
        >
          {{ t.label }}
        </v-tab>
      </v-tabs>

      <template v-if="tab === 'reserves'">
        <div
          class="add"
          @click="openQuickReserve"
          :class="{ disabled: replacing }"
        >
          <Icon name="white_plus" />
          Выделить номера
        </div>
      </template>

      <template v-else>
        <div
          class="add"
          @click="selectNumbers"
          :class="{ disabled: replacing }"
        >
          <Icon name="white_plus" />
          Выделить номера
        </div>
      </template>
    </div>
    <div class="content_table">
      <v-tabs-items v-model="tab">
        <v-tab-item value="carousels">
          <FilterReports
            page_type="carousel_numbers"
            :filter-config="filterConfig.carousel"
            :selects="selects_load"
            :callback="renderCarousel"
            :show-period="false"
            @export="exportCarousel"
          />
          <Table
            :loading="loading_carousel || replacing"
            :headers="table.header_carousel_numbers"
            :data="table.carousel_numbers.data"
            :perPage="perPage"
            :callback_refresh="renderCarousel"
            :hideselect="false"
            page_type="carousels"
            :items="action_items_carousel"
            :items-fn="carouselActions"
            @edit="editCarousel"
            @replace="replaceNumbers"
            @delete="deleteCarousel"
            @export="exportCarouselRow"
            @toggle-carousel="toggleCarousel"
          />
        </v-tab-item>

        <v-tab-item value="all" eager>
          <FilterReports
            page_type="all_numbers"
            :selects="selects_load"
            :filter-config="filterConfig.allNumbers"
            :show-period="false"
            :callback="renderNumbers"
            @export="exportNumbers"
          />
          <Table
            :loading="loading_numbers || replacing"
            :headers="table.header_all_numbers"
            :data="table.all_numbers.data"
            :perPage="perPage"
            :callback_refresh="renderNumbers"
            :hideselect="true"
            page_type="all_numbers"
          />
        </v-tab-item>

        <v-tab-item value="ops" eager>
          <FilterReports
            page_type="ops_history_user"
            :filter-config="filterConfig.opsHistory"
            :selects="selects_load"
            :callback="fetchOpsHistory"
            :show-period="true"
            @export="exportOpsHistory"
          />
          <Table
            :loading="loading_ops"
            :headers="table.header_ops_history"
            :data="table.ops_history.data"
            :perPage="perPage"
            :callback_refresh="fetchOpsHistory"
            :hideselect="true"
            page_type="ops_history_user"
          />
        </v-tab-item>

        <v-tab-item value="reserves" eager>
          <FilterReports
            page_type="user_reserves_self"
            :filter-config="filterConfig.reserves"
            :selects="selects_load"
            :callback="fetchReserves"
            :show-period="true"
            @export="exportReserves"
          />
          <Table
            :loading="loading_reserves"
            :headers="table.header_reserves"
            :data="table.reserves.data"
            :perPage="perPage"
            :callback_refresh="fetchReserves"
            :hideselect="false"
            page_type="user_reserves_self"
            :items="action_items_reserves"
            :items-fn="reserveActions"
            @confirm="reserveConfirm"
            @activate="reserveActivate"
            @edit="reserveEdit"
            @export="reserveExport"
            @delete="reserveDelete"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table/DataTable.vue';
import FilterReports from '@/components/Filter/ReportsFilter.vue';
import SelectNumbersModal from '@/components/SelectNumbersModal.vue';
import EditCarouselModal from '@/components/EditCarouselModal.vue';
import Icon from '@/components/SetIcon.vue';

import QuickReserveModal from '@/components/QuickReserveModal.vue';

import ReserveMarkingModal from '@/components/ReserveMarkingModal.vue';
import EditReserveUserModal from '@/components/EditReserveUserModal.vue';

const OP_LABELS_RU = {
  create: 'Создание',
  replace: 'Замена',
  auto_replace: 'Автозамена',
  auto_renew: 'Автопродление',
  delete: 'Удаление',
  settings: 'Настройки',
};
const STATUS_RU = {
  review: 'На проверке',
  pending: 'Согласование',
  active: 'Активен',
  deleted: 'Удалён',
};

export default {
  name: 'NumbersPage',
  components: {
    Table,
    FilterReports,
    SelectNumbersModal,
    EditCarouselModal,
    Icon,
    QuickReserveModal,
    ReserveMarkingModal,
    EditReserveUserModal,
  },
  data() {
    return {
      tab: 'carousels',
      tabs: [
        { label: 'Карусели номеров', value: 'carousels' },
        { label: 'Все номера', value: 'all' },
        { label: 'История операций', value: 'ops' },
        { label: 'Резервы с маркировкой', value: 'reserves' },
      ],
      perPage: 10,

      loading_carousel: false,
      loading_numbers: false,
      loading_ops: false,
      loading_reserves: false,

      modal: false,
      modalEdit: false,
      modalReserve: false,
      modalReserveUser: false,
      modalReserveQuick: false,

      editingCarousel: null,
      reserveMode: 'create',
      editingReserve: null,
      editingReserveUser: null,

      firstNumbersLoaded: false,
      firstOpsLoaded: false,

      replacing: false,
      snack: { show: false, text: '' },

      filterConfig: {
        carousel: [
          {
            type: 'select',
            field: 'status',
            label: 'Статус карусели',
            items: 'carousel_statuses',
          },
          { type: 'range', field: 'calls', label: 'Звонков с 1 номера' },
        ],
        allNumbers: [
          {
            type: 'select',
            field: 'carousel',
            label: 'Карусель',
            items: 'carousels',
          },
          {
            type: 'select',
            field: 'status',
            label: 'Статус карусели',
            items: 'carousel_statuses',
          },
          { type: 'search', field: 'phone', label: 'Поиск по номеру' },
        ],
        opsHistory: [
          {
            type: 'select',
            field: 'op_type',
            label: 'Тип операции',
            items: 'op_types',
          },
          {
            type: 'select',
            field: 'carousel',
            label: 'Карусель',
            items: 'carousels',
          },
        ],
        reserves: [
          { type: 'period', field: 'created_period', label: 'Период создания' },
          {
            type: 'select',
            field: 'status',
            label: 'Статус резерва',
            items: 'reserve_statuses',
          },
          {
            type: 'select',
            field: 'marking',
            label: 'Маркировка',
            items: 'markings',
          },
        ],
      },

      action_items_carousel: [
        { title: 'Редактировать', action: 'edit' },
        { title: 'Заменить номера', action: 'replace' },
        { title: 'Экспорт', action: 'export' },
        { title: 'Удалить', action: 'delete' },
      ],
      action_items_reserves: [
        { title: 'Редактировать', action: 'edit' },
        { title: 'Удалить', action: 'delete' },
      ],

      selects_load: {
        carousels: [],
        carousel_statuses: [
          { id: 'active', name: 'Активна' },
          { id: 'in', name: 'Только входящие' },
        ],
        op_types: [
          { id: 'create', name: 'Создание' },
          { id: 'replace', name: 'Замена' },
          { id: 'auto_replace', name: 'Автозамена' },
          { id: 'auto_renew', name: 'Автопродление' },
          { id: 'delete', name: 'Удаление' },
        ],
        reserve_statuses: [
          { id: 'pending', name: 'Согласование' },
          { id: 'active', name: 'Активен' },
          { id: 'review', name: 'На проверке' },
        ],
        markings: [],
      },

      table: {
        carousel_numbers: { data: [] },
        all_numbers: { data: [] },
        ops_history: { data: [] },
        reserves: { data: [] },

        header_carousel_numbers: [
          { text: 'Карусель / сегмент', value: 'carousel' },
          { text: 'Номеров', value: 'numbersCount' },
          { text: 'Статус', value: 'carouselStatus' },
          { text: 'Маркировка', value: 'marking' },
          { text: 'Ср. звонков с 1 номера', value: 'callsPerNumber' },
          { text: 'Дозвон', value: 'answerRate' },
          { text: 'Автозамена', value: 'autoReplaceRule' },
          { text: 'Последняя замена', value: 'lastAutoReplace' },
          { text: 'Автопродление', value: 'autoRenew' },
          { text: 'Последний исходящий вызов', value: 'lastOutboundCall' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
        header_all_numbers: [
          { text: 'Номер', value: 'phoneNumber' },
          { text: 'Статус номера', value: 'numberStatus' },
          { text: 'Карусель', value: 'carousel' },
          { text: 'Направление', value: 'direction' },
          { text: 'Скрипт входящего', value: 'incomingScript' },
          {
            text: 'Исходящих звонков',
            value: 'outboundCalls',
          },
          { text: 'Начало аренды', value: 'rentStart' },
          { text: 'Окончание аренды', value: 'rentEnd' },
          { text: 'Стоимость', value: 'rentCost' },
          { text: 'Автопродление', value: 'autoRenew' },
          {
            text: 'Последний исходящий',
            value: 'lastOutboundCall',
            cellClass: 'no-wrap',
          },
        ],
        header_ops_history: [
          { text: 'Карусель', value: 'carousel' },
          { text: 'Тип операции', value: 'opType' },
          { text: 'Количество номеров', value: 'numbersCount' },
          { text: 'Стоимость', value: 'cost' },
          { text: 'Дата', value: 'createdAt' },
        ],
        header_reserves: [
          { text: 'Резерв', value: 'reserve' },
          { text: 'Статус', value: 'reserveStatus' },
          // { text:'Количество номеров', value:'numbersCount' },
          { text: 'Доступно в резерве', value: 'available' },
          { text: 'Стоимость аренды', value: 'rentCost' },
          { text: 'Маркировка', value: 'marking' },
          { text: 'Создан', value: 'createdAt' },
          { text: 'Начало аренды', value: 'rentStart' },
          { text: 'Окончание аренды', value: 'rentEnd' },
          { text: 'Автопродление', value: 'autoRenew' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
      },
      carouselSource: [],
      expandedCarousels: {},
    };
  },
  created() {
    this.renderCarousel({});
  },
  watch: {
    tab(val) {
      if (val === 'all' && !this.firstNumbersLoaded) {
        this.firstNumbersLoaded = true;
        this.renderNumbers({});
      }
      if (val === 'ops' && !this.firstOpsLoaded) {
        this.firstOpsLoaded = true;
        this.fetchOpsHistory({});
      }
      if (
        val === 'reserves' &&
        this.table.reserves.data.length === 0 &&
        !this.loading_reserves
      ) {
        this.fetchReserves({});
      }
    },
  },
  mounted() {
    this.$root.$on('carousel-export-start', () => {
      this.loading_carousel = true;
    });

    this.$root.$on('carousel-export-end', () => {
      this.loading_carousel = false;
    });
  },
  methods: {
    getAutoReplaceRuleSignature(row) {
      const enabled =
        typeof row?.autoReplaceOn === 'boolean'
          ? row.autoReplaceOn
          : row?.autoreplace === true || String(row?.autoreplace) === '1';

      if (!enabled) return 'off';

      const type = row.auto_replace_type || row.autoReplaceType || 'schedule';

      if (type === 'threshold') {
        const threshold = Number(
          row.auto_calls_threshold || row.autoCallsThreshold || 10,
        );

        return `threshold:${threshold}`;
      }

      return `schedule:${row.auto_schedule_json || ''}`;
    },
    formatAutoReplaceRule(row) {
      const enabled =
        typeof row?.autoReplaceOn === 'boolean'
          ? row.autoReplaceOn
          : row?.autoreplace === true || String(row?.autoreplace) === '1';

      if (!enabled) return 'Отключена';

      const type = row.auto_replace_type || row.autoReplaceType || 'schedule';

      if (type === 'threshold') {
        const threshold = Number(
          row.auto_calls_threshold || row.autoCallsThreshold || 10,
        );

        return `Порог ${threshold}`;
      }

      return 'По расписанию';
    },
    carouselActions(row, items) {
      if (row.rowType === 'segment') {
        return items.filter(
          (item) => item.action === 'edit' || item.action === 'replace',
        );
      }
      // if (row.rowType === 'parent' && row.carouselType === 'operator') {
      //   return items.filter((item) => item.action !== 'replace');
      // }

      return items;
    },
    buildCarouselRows(source) {
      const rows = [];

      for (const carousel of source || []) {
        const segments = Array.isArray(carousel.segments)
          ? carousel.segments
          : [];

        const segmentRules = segments.map((segment) =>
          this.formatAutoReplaceRule(segment),
        );

        const segmentRuleSignatures = segments.map((segment) =>
          this.getAutoReplaceRuleSignature(segment),
        );

        const uniqueSegmentRules = [...new Set(segmentRuleSignatures)];

        const enabledSegments = segmentRules.filter(
          (rule) => rule !== 'Отключена',
        ).length;

        const parentAutoReplaceRule =
          carousel.carouselType === 'operator'
            ? uniqueSegmentRules.length === 1
              ? segmentRules[0]
              : 'Разные правила'
            : this.formatAutoReplaceRule(carousel);
        const parent = {
          ...carousel,
          id: carousel.id,
          guid: carousel.id,
          carouselId: carousel.id,
          rowType: 'parent',
          selectDisabled: false,
          autoReplaceRule: parentAutoReplaceRule,

          autoReplaceSummary:
            carousel.carouselType === 'operator'
              ? `Включено: ${enabledSegments} из ${segments.length}`
              : '',
          expanded: this.expandedCarousels[carousel.id] === true,
          rentStart: this.fmtDateOnly(carousel.rentStart),
          rentEnd: this.fmtDateOnly(carousel.rentEnd),
          createdAt: this.fmtDateOnly(carousel.createdAt),
          lastOutboundCall: this.fmtDateOnly(carousel.lastOutboundCall),
          incoming_script_id: carousel.incoming_script_id || null,
          marking: carousel.markingName || carousel.marking || '—',
          markingId: carousel.markingId || null,
        };

        rows.push(parent);

        if (
          carousel.carouselType !== 'operator' ||
          !Array.isArray(carousel.segments) ||
          !parent.expanded
        ) {
          continue;
        }

        for (const segment of carousel.segments) {
          rows.push({
            ...parent,
            ...segment,

            id: `${carousel.id}:${segment.key}`,
            guid: `${carousel.id}:${segment.key}`,
            carouselId: carousel.id,

            rowType: 'segment',
            selectDisabled: true,
            segment: segment.key,
            carousel: segment.title,

            numbersCount: Number(segment.numbersCount ?? segment.count ?? 0),
            callsPerNumber: Number(segment.callsPerNumber || 0),
            autoReplaceRule: this.formatAutoReplaceRule(segment),

            rentStart: this.fmtDateOnly(segment.rentStart),
            rentEnd: this.fmtDateOnly(segment.rentEnd),
            createdAt: this.fmtDateOnly(segment.createdAt),
            lastOutboundCall: this.fmtDateOnly(segment.lastOutboundCall),

            rentCost: '—',
            marking: '—',
            autoRenew: '—',
            lastAutoReplace: segment.lastAutoReplace || '—',
          });
        }
      }

      return rows;
    },
    toggleCarousel(row) {
      if (row.rowType !== 'parent' || row.carouselType !== 'operator') {
        return;
      }

      const current = this.expandedCarousels[row.carouselId] === true;

      this.$set(this.expandedCarousels, row.carouselId, !current);

      this.table.carousel_numbers.data = this.buildCarouselRows(
        this.carouselSource,
      );
    },
    fmtDateOnly(val) {
      if (!val) return '—';
      if (/^\d{2}\.\d{2}\.\d{4}$/.test(String(val))) return String(val);
      const safe = String(val).replace(' ', 'T');
      const d = new Date(safe);
      if (isNaN(d)) {
        const m = String(val).match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return `${m[3]}.${m[2]}.${m[1]}`;
        return '—';
      }
      const p = (n) => String(n).padStart(2, '0');
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
    },
    openQuickReserve() {
      this.modalReserveQuick = true;
    },
    onQuickReserveCreated({ total }) {
      this.snack = {
        show: true,
        text: `Заявка создана (на проверке): на ${this.fmtRub(total)}`,
      };
      this.fetchReserves({});
    },

    async saveReserveUser(form) {
      try {
        const payload = {
          id: form.id,
          title: form.title,
          autorenew: !!form.autorenew,
        };
        const resp = await new Promise((resolve) =>
          this.$http.post('/numbers/reserves/update_user', payload, (r) =>
            resolve(r),
          ),
        );
        if (resp === 'error' || !resp?.ok) {
          this.snack = {
            show: true,
            text: (resp && resp.message) || 'Не удалось сохранить резерв',
          };
          return;
        }
        this.snack = { show: true, text: 'Настройки резерва сохранены' };
        this.modalReserveUser = false;
        this.editingReserveUser = null;
        this.fetchReserves({});
      } catch {
        this.snack = { show: true, text: 'Ошибка сети' };
      }
    },

    formatRuPhone(val) {
      const s = String(val || '');
      const digits = s.replace(/\D/g, '');
      if (digits.length < 10) return s;
      const local = digits.slice(-10);
      return `+7 (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(
        6,
        8,
      )}-${local.slice(8, 10)}`;
    },
    fmtRub(v) {
      const n = Number(v || 0);
      try {
        return new Intl.NumberFormat('ru-RU').format(n) + ' ₽';
      } catch {
        return n + ' ₽';
      }
    },
    normalizeIdsFilter(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val.map((x) => x?.id ?? x).filter(Boolean);
      const one = val?.id ?? val;
      return one ? [one] : [];
    },
    fmtDateTime(iso) {
      if (!iso) return '—';
      const safe = typeof iso === 'string' ? iso.replace(' ', 'T') : iso;
      const d = new Date(safe);
      if (isNaN(d)) return '—';
      const p = (n) => String(n).padStart(2, '0');
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(
        d.getHours(),
      )}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },

    selectNumbers() {
      this.modal = true;
      this.$nextTick(() => {
        const dlg = this.$refs.selModal;
        if (dlg) {
          dlg.type = 'new';
          dlg.selectedCarousel = null;
          dlg.selectedSegment = null;
          dlg.selectedTrunk = null;
          dlg.loadCarouselCountRule();
        }
      });
    },

    editCarousel(row) {
      this.editingCarousel = {
        id: row.carouselId || row.id,
        segment: row.segment || null,
        title: row.carousel,
        status:
          row.status ||
          (row.carouselStatus === 'Только входящие' ? 'in' : 'active'),
        autorenew: row.autoRenew === 'Включено',
        autoreplace: Boolean(row.autoReplaceOn),
        days: row.days || ['mon'],
        time: row.time || '20:00',
        amount: row.amount ?? row.numbersCount ?? 0,
        autoSource: row.auto_source ?? row.autoSource ?? 'regular',
        autoReserveId: row.auto_reserve_id ?? row.autoReserveId ?? null,
        user: row.user || null,
        scriptId: row.incoming_script_id || row.scriptId || null,

        auto_replace_type:
          row.auto_replace_type || row.autoReplaceType || 'schedule',
        auto_calls_threshold: Number(
          row.auto_calls_threshold || row.autoCallsThreshold || 1000,
        ),
        auto_schedule_json: row.auto_schedule_json || '',
        rowType: row.rowType,
        carouselType: row.carouselType,
      };
      this.modalEdit = true;
    },

    saveCarousel(form) {
      if (!this.editingCarousel || !this.editingCarousel.id) {
        this.modalEdit = false;
        return;
      }
      const isSegment = Boolean(this.editingCarousel.segment);

      const isOperatorParent =
        this.editingCarousel.rowType === 'parent' &&
        this.editingCarousel.carouselType === 'operator';
      const commonSettings = {
        title: form.title,
        status: form.status,
        autorenew: !!form.autorenew,
        incoming_script_id: form.incoming_script_id ?? form.scriptId ?? '',
      };

      const autoSettings = {
        autoreplace: !!form.autoreplace,
        days: Array.isArray(form.days) ? form.days : [],
        time: form.time,
        amount: Number(form.amount) || 0,
        auto_source: form.auto_source ?? form.autoSource ?? 'regular',
        auto_reserve_id: form.auto_reserve_id ?? form.autoReserveId ?? '',
        auto_replace_type:
          form.auto_replace_type ?? form.autoReplaceType ?? 'schedule',
        auto_calls_threshold: Math.max(
          10,
          Number(form.auto_calls_threshold ?? form.autoCallsThreshold ?? 10) ||
            10,
        ),
        auto_schedule_json: form.auto_schedule_json || '',
      };

      const payload = {
        id: this.editingCarousel.id,

        ...(isSegment
          ? {
              segment: this.editingCarousel.segment,
              ...autoSettings,
            }
          : isOperatorParent
          ? commonSettings
          : {
              ...commonSettings,
              ...autoSettings,
            }),
      };
      console.log('[carousel_update payload]', payload);
      this.$http.post('/numbers/carousel_update', payload, (resp) => {
        if (resp === 'error' || !resp?.ok) {
          this.snack = {
            show: true,
            text: (resp && resp.message) || 'Не удалось сохранить настройки',
          };
          return;
        }
        this.modalEdit = false;
        this.snack = { show: true, text: 'Настройки сохранены' };
        this.renderCarousel({});
        if (this.firstOpsLoaded) this.fetchOpsHistory({});
      });
    },

    replaceNumbers(row) {
      this.modal = true;
      this.$nextTick(() => {
        const dlg = this.$refs.selModal;
        if (dlg) {
          dlg.type = 'replace';
          dlg.selectedSegment = row.rowType === 'segment' ? row.segment : null;
          dlg.selectedTrunk = row.rowType === 'segment' ? row.trunk : null;
          dlg.selectedCarousel = row.carouselId || row.id;

          dlg.amount =
            row.rowType === 'segment'
              ? Number(row.numbersCount || row.count || 0)
              : dlg.amount;

          dlg.numbersKind = 'regular';
          dlg.loadCarouselCountRule();
        }
      });
    },

    deleteCarousel(row) {
      if (
        !confirm(
          `Удалить карусель «${row.carousel}»?\nЭто действие необратимо.`,
        )
      )
        return;
      this.$http.post('/numbers/carousel_delete', { id: row.id }, (res) => {
        if (res === 'error' || !res?.ok) {
          alert('Ошибка: не удалось удалить карусель');
          return;
        }
        this.renderCarousel({});
        if (this.firstOpsLoaded) this.fetchOpsHistory({});
      });
    },

    handleConfirm({
      carouselId,
      segment,
      amount,
      numbersKind,
      reserveId,
      incoming_script_id = '',
    }) {
      this.replacing = true;
      const isSegmentReplace = !!segment;
      const isReserveReplace =
        !isSegmentReplace && numbersKind === 'reserve' && !!reserveId;
      const url = isReserveReplace
        ? '/numbers/create_carousel_from_reserve'
        : '/numbers/carousel/replace_numbers';

      const payload = isSegmentReplace
        ? {
            carouselId,
            segment,
          }
        : isReserveReplace
        ? {
            title: '',
            reserveId,
            count: Number(amount),
            prevCarouselId: carouselId,
            incoming_script_id: incoming_script_id || '',
          }
        : {
            carouselId,
            count: Number(amount),
          };

      this.$http.post(url, payload, (res) => {
        this.replacing = false;
        if (res === 'error' || !res?.ok) {
          this.snack = {
            show: true,
            text: (res && res.message) || 'Ошибка: не удалось заменить номера',
          };
          return;
        }
        this.snack = {
          show: true,
          text: isSegmentReplace
            ? 'Сегмент успешно заменён'
            : isReserveReplace
            ? 'Замена выполнена: создана новая карусель из резерва'
            : 'Номера карусели успешно заменены',
        };
        this.renderCarousel({});
        if (this.firstOpsLoaded) this.fetchOpsHistory({});
        if (this.tab === 'reserves') this.fetchReserves({});
      });
    },

    handleCreated() {
      this.renderCarousel({});
      if (this.firstOpsLoaded) this.fetchOpsHistory({});
    },

    renderCarousel(filters = {}) {
      this.loading_carousel = true;
      this.$http.post('/numbers/carousel', filters, (resp) => {
        if (resp !== 'error' && Array.isArray(resp)) {
          this.carouselSource = resp;

          this.table.carousel_numbers.data = this.buildCarouselRows(resp);
          this.selects_load.carousels = resp.map((r) => ({
            id: r.id,
            name: r.carousel,
            count: r.numbersCount,
          }));
        }
        this.loading_carousel = false;
      });
    },

    renderNumbers(filters = {}) {
      this.loading_numbers = true;
      this.$http.post('/numbers/all', filters, (resp) => {
        if (resp !== 'error' && Array.isArray(resp)) {
          this.table.all_numbers.data = resp.map((r) => ({
            ...r,
            _phoneRaw: r.phoneNumber,
            phoneNumber: this.formatRuPhone(r.phoneNumber),
            rentStart: this.fmtDateOnly(r.rentStart),
            rentEnd: this.fmtDateOnly(r.rentEnd),
            lastOutboundCall: this.fmtDateOnly(r.lastOutboundCall),
          }));
        }
        this.loading_numbers = false;
      });
    },

    async fetchOpsHistory(filters = {}) {
      this.loading_ops = true;
      try {
        const payload = {
          op_type: filters.op_type?.id ?? filters.op_type ?? '',
          carousel: filters.carousel?.id ?? filters.carousel ?? '',
          startDate: filters.startDate,
          endDate: filters.endDate,
          startTime: filters.startTime,
          endTime: filters.endTime,
          limit: 300,
        };
        if (String(payload.op_type).toLowerCase() === 'settings')
          payload.op_type = '';
        const resp = await new Promise((resolve) =>
          this.$http.post('/numbers/carousel_events', payload, (r) =>
            resolve(r),
          ),
        );
        const rows = (Array.isArray(resp) ? resp : []).filter(
          (r) => String(r.operation || '').toLowerCase() !== 'settings',
        );
        this.table.ops_history.data = rows.map((r) => ({
          id: r.id || r.carousel_id,
          carousel: r.carousel_title || r.carouselTitle || '—',
          opType:
            OP_LABELS_RU[(r.operation || '').toLowerCase()] ||
            r.operation ||
            '—',
          numbersCount: Number(r.numbers_count ?? r.numbersCount ?? 0),
          cost: this.fmtRub(r.amount ?? 0),
          createdAt: this.fmtDateTime(
            r.event_time || r.created_at || r.createdAt,
          ),
        }));
      } finally {
        this.loading_ops = false;
      }
    },

    async fetchReserves(filters = {}) {
      this.loading_reserves = true;
      try {
        if (!this.selects_load.markings.length) {
          try {
            const m = await new Promise((resolve) =>
              this.$http.post('/numbers/markings/list', {}, (r) => resolve(r)),
            );
            const arr = Array.isArray(m?.markings) ? m.markings : [];
            this.selects_load.markings = arr.map((x) => ({
              id: x.id,
              name: x.name,
            }));
          } catch {
            console.log();
          }
        }
        const payload = {
          status: filters.status?.id ?? filters.status ?? '',
          marking: filters.marking?.id ?? filters.marking ?? '',
          startDate: filters.startDate,
          endDate: filters.endDate,
        };
        const resp = await new Promise((resolve) =>
          this.$http.post('/numbers/reserves/list', payload, (r) => resolve(r)),
        );
        const rows = Array.isArray(resp) ? resp : [];
        this.table.reserves.data = rows.map((r) => {
          const code = String(r.status || '').toLowerCase();
          const autorenewBool =
            typeof r.autorenew === 'boolean'
              ? r.autorenew
              : String(r.autoRenew || '')
                  .toLowerCase()
                  .includes('включ');
          const avail = Number(r.available ?? 0) || 0;
          const ppn = Number(r.price ?? 0) || 0;
          return {
            id: r.id,
            title: r.title || r.reserve || '',
            statusCode: code,
            reserve: r.title || r.reserve || '—',
            reserveStatus: STATUS_RU[code] || '—',
            numbersCount: Number(r.numbersCount || 0),
            available: String(avail),
            rentCost: this.fmtRub(avail * ppn),
            marking: r.marking || '—',
            markingId: r.markingId || null,
            price: ppn,
            trunks: Array.isArray(r.trunks) ? r.trunks : [],
            createdAt: this.fmtDateOnly(r.createdAt),
            rentStart: this.fmtDateOnly(r.rentStart),
            rentEnd: this.fmtDateOnly(r.rentEnd),
            autoRenew:
              r.autoRenew || (autorenewBool ? 'Включено' : 'Отключено'),
            autorenew: autorenewBool,
          };
        });
      } finally {
        this.loading_reserves = false;
      }
    },

    exportReserves() {
      this.snack = {
        show: true,
        text: 'Экспортируйте по кнопке «Экспорт» у нужной строки.',
      };
    },

    reserveActions(row, base) {
      const byStatus = {
        review: ['confirm', 'edit', 'delete'],
        pending: ['activate', 'edit', 'export', 'delete'],
        active: ['edit', 'export', 'delete'],
      };
      const allow = byStatus[String(row?.statusCode || '')] || [];
      return base.filter((it) => allow.includes(it.action));
    },

    reserveConfirm(row) {
      if (!row?.id) return;
      if ((row.statusCode || '') !== 'review') {
        this.snack = {
          show: true,
          text: 'Подтверждать можно только заявки «На проверке»',
        };
        return;
      }
      if (!confirm('Подтвердить заявку и забронировать номера из резерва?'))
        return;
      this.loading_reserves = true;
      this.$http.post('/numbers/reserves/confirm', { id: row.id }, (resp) => {
        this.loading_reserves = false;
        if (resp === 'error' || !resp?.ok) {
          this.snack = {
            show: true,
            text: (resp && resp.message) || 'Не удалось подтвердить',
          };
          return;
        }
        this.snack = { show: true, text: 'Заявка переведена в согласование' };
        this.fetchReserves({});
      });
    },

    reserveActivate(row) {
      if (!row?.id) return;
      if ((row.statusCode || '') !== 'pending') {
        this.snack = {
          show: true,
          text: 'Активировать можно только заявки «Согласование»',
        };
        return;
      }
      if (!confirm('Активировать резерв и начать аренду номеров?')) return;
      this.loading_reserves = true;
      this.$http.post('/numbers/reserves/activate', { id: row.id }, (resp) => {
        this.loading_reserves = false;
        if (resp === 'error' || !resp?.ok) {
          this.snack = {
            show: true,
            text: (resp && resp.message) || 'Не удалось активировать',
          };
          return;
        }
        this.snack = { show: true, text: 'Резерв активирован' };
        this.fetchReserves({});
      });
    },

    reserveDelete(row) {
      if (!row?.id) return;
      const msg =
        'Удалить резерв? Для «Согласование»/«Активен» номера будут возвращены согласно правилам.';
      if (!confirm(msg)) return;
      this.loading_reserves = true;
      this.$http.post('/numbers/reserves/delete', { id: row.id }, (resp) => {
        this.loading_reserves = false;
        if (resp === 'error' || !resp?.ok) {
          this.snack = {
            show: true,
            text: (resp && resp.message) || 'Не удалось удалить резерв',
          };
          return;
        }
        this.snack = { show: true, text: 'Резерв удалён' };
        this.fetchReserves({});
      });
    },

    reserveEdit(row) {
      this.editingReserveUser = {
        id: row.id,
        title: row.title || row.reserve || '',
        autorenew: !!row.autorenew,
      };
      this.modalReserveUser = true;
    },

    async reserveExport(row) {
      try {
        const res = await fetch('/numbers/reserves/export', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: row.id }),
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `reserve_${row.id}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch {
        this.snack = { show: true, text: 'Экспорт не удался' };
      }
    },

    async exportXlsx(fileName, sheetName, rows = []) {
      if (!Array.isArray(rows) || !rows.length) {
        this.snack = { show: true, text: 'Нет данных для экспорта' };
        return;
      }

      const { default: ExcelJS } = await import('exceljs');

      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet(sheetName);

      const headers = Object.keys(rows[0]);
      ws.addRow(headers);

      rows.forEach((row) => {
        ws.addRow(headers.map((key) => row[key]));
      });

      ws.getRow(1).font = { bold: true };

      ws.columns = headers.map((key) => ({
        key,
        width: Math.min(
          40,
          Math.max(
            String(key).length + 2,
            ...rows.map((row) => String(row[key] ?? '').length + 2),
          ),
        ),
      }));

      const buffer = await wb.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },

    openReserveModal() {
      this.reserveMode = 'create';
      this.editingReserve = null;
      this.modalReserve = true;
    },
    onReserveCreate() {
      this.snack = { show: true, text: 'Заявка создана (черновик)' };
      this.reserveMode = 'create';
      this.fetchReserves({});
    },
    onReserveSave() {
      this.snack = { show: true, text: 'Изменения сохранены' };
      this.reserveMode = 'create';
      this.editingReserve = null;
      this.fetchReserves({});
    },

    async exportCarousel(filters = {}) {
      try {
        this.loading_carousel = true;
        const carouselPayload = {
          ...filters,
          status: filters.status?.id ?? filters.status ?? '',
          calls_from: filters.calls_from ?? filters.calls?.from ?? '',
          calls_to: filters.calls_to ?? filters.calls?.to ?? '',
        };

        const carousels = await new Promise((resolve) =>
          this.$http.post('/numbers/carousel', carouselPayload, (r) =>
            resolve(r),
          ),
        );

        if (
          carousels === 'error' ||
          !Array.isArray(carousels) ||
          !carousels.length
        ) {
          this.snack = { show: true, text: 'Нет данных для экспорта' };
          return;
        }

        const carouselIds = carousels.map((x) => x.id).filter(Boolean);

        if (!carouselIds.length) {
          this.snack = { show: true, text: 'Нет каруселей для экспорта' };
          return;
        }

        const numbersPayload = {
          carousel: carouselIds,
          active_only: true,
        };

        const resp = await new Promise((resolve) =>
          this.$http.post('/numbers/all', numbersPayload, (r) => resolve(r)),
        );

        if (resp === 'error' || !Array.isArray(resp) || !resp.length) {
          this.snack = { show: true, text: 'Нет номеров для экспорта' };
          return;
        }

        const rows = resp.map((r) => ({
          Номер: this.formatRuPhone(r.phoneNumber),
          'Исходящих звонков совершено': r.outboundCalls ?? '—',
          Карусель: r.carousel ?? '—',
          'Статус карусели': r.carouselStatus ?? '—',
          'Начало аренды': this.fmtDateOnly(r.rentStart),
          'Окончание аренды': this.fmtDateOnly(r.rentEnd),
          'Стоимость аренды': r.rentCost ?? '—',
          Автопродление: r.autoRenew ?? '—',
          'Последний исходящий вызов': this.fmtDateOnly(r.lastOutboundCall),
        }));
        this.loading_carousel = false;
        await this.exportXlsx('carousel_numbers.xlsx', 'Numbers', rows);
      } catch {
        this.snack = { show: true, text: 'Экспорт не удался' };
      }
    },
    async exportNumbers(filters = {}) {
      try {
        this.loading_numbers = true;
        const resp = await new Promise((resolve) =>
          this.$http.post('/numbers/all', filters, (r) => resolve(r)),
        );

        if (resp === 'error' || !Array.isArray(resp) || !resp.length) {
          this.snack = { show: true, text: 'Нет данных для экспорта' };
          return;
        }

        const rows = resp.map((r) => ({
          Номер: this.formatRuPhone(r.phoneNumber),
          'Статус номера': r.numberStatus ?? '—',
          Карусель: r.carousel ?? '—',
          Направление: r.direction ?? '—',
          'Скрипт входящего': r.incomingScript ?? '—',
          'Исходящих звонков': r.outboundCalls ?? '—',
          'Начало аренды': this.fmtDateOnly(r.rentStart),
          'Окончание аренды': this.fmtDateOnly(r.rentEnd),
          Стоимость: r.rentCost ?? '—',
          Автопродление: r.autoRenew ?? '—',
          'Последний исходящий': this.fmtDateOnly(r.lastOutboundCall),
        }));
        this.loading_numbers = false;
        await this.exportXlsx('numbers.xlsx', 'Numbers', rows);
      } catch {
        this.snack = { show: true, text: 'Экспорт не удался' };
      }
    },
    async exportCarouselRow(row) {
      try {
        this.loading_carousel = true;
        if (!row?.id) {
          this.snack = { show: true, text: 'Не найдена карусель для экспорта' };
          return;
        }
        const resp = await new Promise((resolve) =>
          this.$http.post(
            '/numbers/all',
            { carousel: row.id, active_only: true },
            (r) => resolve(r),
          ),
        );

        if (resp === 'error' || !Array.isArray(resp) || !resp.length) {
          this.snack = { show: true, text: 'Нет номеров для экспорта' };
          return;
        }

        const rows = resp.map((r) => ({
          Номер: this.formatRuPhone(r.phoneNumber),
          'Исходящих звонков совершено': r.outboundCalls ?? '—',
          Карусель: r.carousel ?? '—',
          'Статус карусели': r.carouselStatus ?? '—',
          'Начало аренды': this.fmtDateOnly(r.rentStart),
          'Окончание аренды': this.fmtDateOnly(r.rentEnd),
          'Стоимость аренды': r.rentCost ?? '—',
          Автопродление: r.autoRenew ?? '—',
          'Последний исходящий вызов': this.fmtDateOnly(r.lastOutboundCall),
        }));

        const safeName = String(row.carousel || 'carousel')
          .replace(/[^\wа-яА-ЯёЁ-]+/g, '_')
          .replace(/_+/g, '_')
          .replace(/^_+|_+$/g, '');

        this.loading_carousel = false;
        await this.exportXlsx(
          `${safeName || 'carousel'}.xlsx`,
          'Numbers',
          rows,
        );
      } catch {
        this.snack = { show: true, text: 'Экспорт не удался' };
      }
    },
    async exportOpsHistory(filters = {}) {
      const payload = {
        op_type: filters.op_type?.id ?? filters.op_type ?? '',
        carousel: filters.carousel?.id ?? filters.carousel ?? '',
        startDate: filters.startDate,
        endDate: filters.endDate,
        startTime: filters.startTime,
        endTime: filters.endTime,
        exclude_settings: true,
      };

      if (String(payload.op_type).toLowerCase() === 'settings') {
        payload.op_type = '';
      }

      if (sessionStorage.token) {
        payload.token = sessionStorage.token;
      }

      try {
        this.loading_ops = true;

        const response = await this.$http.axios.post(
          '/numbers/carousel_events/export',
          payload,
          {
            responseType: 'blob',
          },
        );

        const blob = response.data;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = 'carousel_events.xlsx';

        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('[exportOpsHistory]', error);

        this.snack = {
          show: true,
          text: 'Не удалось выгрузить историю операций',
        };
      } finally {
        this.loading_ops = false;
      }
    },
  },
};
</script>

<style scoped>
.content_table {
  margin-top: 24px;
}
.top_actions {
  display: flex;
  justify-content: flex-end;
  margin: 24px 0 16px;
}

.filters-bar {
  display: flex;
  align-items: flex-end;
  background: #fff4e8;
  padding: 22px 32px;
  border-radius: 8px 8px 0 0;
}

.my_toolbar {
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
}

.tabs {
  flex: 1;
}

.select-btn {
  height: 40px;
  background: #4b5eff !important;
  border-radius: 8px !important;
  font: 600 15px/120% inherit;
  color: #fff !important;
  text-transform: none;
  padding: 10px 22px;
  display: flex;
  align-items: center;
}

.select-btn ::v-deep(.icon),
.select-btn ::v-deep(svg),
.select-btn ::v-deep(path) {
  color: #fff !important;
  fill: #fff !important;
  stroke: #fff !important;
}

.select-btn.v-btn--disabled {
  color: #fff !important;
  opacity: 0.6;
}
.select-btn.v-btn--disabled ::v-deep(svg),
.select-btn.v-btn--disabled ::v-deep(path) {
  fill: #fff !important;
  stroke: #fff !important;
}

.blocks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.no-wrap {
  white-space: nowrap;
}
.add {
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #eee;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
  align-items: center;
}
.add .icon {
  margin-right: 11px;
}
.add.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.add .icon {
  margin-right: 11px;
}

.item_tab {
  text-transform: none !important;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #808185;
}

.my_active_tab {
  color: #2b2d33;
}

.my_toolbar {
  margin-top: 16px;
}

.num_big {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  text-align: center;
  color: #404247;
  max-width: 75px;
  position: absolute;
  top: 55px;
  width: 75px;
  left: 51px;
}

.block_item {
  padding: 16px 24px;
  border-radius: 8px;

  width: 265px;
  margin-bottom: 36px;
}

.block_item:nth-child(odd) {
  margin-right: 20px;
}

.small_blocks {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: center;
}

.block_item .heading {
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
  margin-bottom: 12px;
  text-align: left;
}

.block_item .num {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  color: #404247;
  text-align: left;
}

.my_red .num {
  color: #ee505a;
}

.my_gray {
  background: #f8f8f8;
}

.my_red {
  background: #fdeeee;
}

.my_green {
  background: #e8f7f4;
}

.block {
  display: flex;
  flex-wrap: wrap;
  padding: 32px 24px;
  justify-content: center;
  max-width: 600px;
}

.big_block {
  background: #e8f7f4;
  border-radius: 8px;
  display: flex;
  padding: 24px 16px;
  min-width: 500px;
  max-height: 230px;
}

.right {
  margin-left: 32px;
}

.heading {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  text-align: left;
  line-height: 130%;
  color: #404247;
}

.robot,
.client,
.silence {
  text-align: left;
  position: relative;
  margin-top: 24px;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  padding-left: 25px;
  line-height: 120%;
  color: #404247;
}

.robot:before {
  display: block;
  content: '';
  width: 18px;
  height: 18px;
  background: #faa373;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.client:before {
  display: block;
  content: '';
  width: 18px;
  height: 18px;
  background: #57b6ed;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.silence:before {
  display: block;
  content: '';
  width: 18px;
  height: 18px;
  background: #9a99fb;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.content {
  height: 100%;
  display: flex;
  position: relative;
  z-index: 1000;
}

.empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 500px;
}
.select-btn.texty {
  background: #eef0ff !important;
  color: #2b2d33 !important;
}
.subtitle {
  max-width: 450px;
  margin-bottom: 32px;
}

.left {
  position: relative;
}
.overlay-box {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 16px 20px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.overlay-title {
  font: 700 16px/1.2 Manrope, sans-serif;
  color: #2b2d33;
}
.overlay-sub {
  font: 500 13px/1.3 Manrope, sans-serif;
  color: #6f7075;
  margin-top: 4px;
}
@media (max-width: 1000px) {
  .filters {
    flex-direction: column;
  }
}

@media (max-width: 650px) {
  .top {
    justify-content: center;
  }

  .big_block {
    flex-direction: column;
    max-height: initial;
    min-width: initial;
  }

  .num_big {
    left: calc(50% - 36px);
  }

  .right {
    margin-left: 0;
  }

  /* тулбар: табы сверху, маленькая кнопка под ними слева */
  .my_toolbar {
    flex-direction: column;
    align-items: flex-start; /* выравниваем по левому краю */
    gap: 8px;
  }

  .my_toolbar .tabs {
    width: 100%;
    min-width: 0; /* чтобы табы не разъезжались */
  }

  .my_toolbar .add {
    width: 180px !important; /* не во всю ширину */
    margin: 8px auto 0 !important;
    padding: 6px 10px !important;
    height: 34px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
  }

  /* уменьшаем иконку */
  .my_toolbar .add .icon,
  .my_toolbar .add svg {
    width: 14px !important;
    height: 14px !important;
  }
}

@media (max-width: 620px) {
  .block_item:nth-child(odd) {
    margin-right: 0;
  }

  .small_blocks {
    flex-direction: column;
  }
}

@media (max-width: 400px) {
  h1 {
    margin-top: 15px;
  }
}
</style>
